/*
 * @Author: yaoyc
 * @since: 2021-07-31 17:01:19
 * @LastAuthor: yaoyc
 * @lastTime: 2021-08-01 22:54:35
 * @FilePath: /app-client-p/src/utils/upload.ts
 * @Description:
 */
import { PickerResult } from './PicOrCameraManager';
import { isIos } from '../AppEvent';
import ReactBlobUtil, { UploadKey } from './ReactBlobUtil';
import { CryptEngine } from './CryptEngine';
import { MessageType } from '../constants/types';
import { Str_FileSizeLimit, Str_NoSupportFileType } from '../language/string_res';
import * as imSdk from '../../imsdk/api';

export interface UploadProgressImageCallback {
	onSuccess?: (url: string) => void;
	onFail?: (msg?: string) => void;
}
//七牛 ?vframe/jpg/offset/1，拼接在视频链接后可以获取视频第一帧
//七牛 ?avinf，拼接在视频链接后可以获取视频所有信息。
//七牛 ?imageView2/1/w/100/h/200/q/20 拼接在图片链接后可以对图片进行处理,w/100/h/200这两个是控制图片尺寸，q/20 图片进行质量压缩
//?imageInfo 拼接在图片链接后获取图片信息
// http://78re52.com1.z0.glb.clouddn.com/docs/v6/api/reference/fop/image/imageinfo.html
export const uploadProgressFile = async (
	response: PickerResult,
	sender: number,
	cid: string,
	docSize?: number,
): Promise<{ code: number; cid: string; msg?: string; url?: string }> => {
	return uploadFiles(UploadKey.Chat, response, sender, cid, docSize);
};

// 上传函数
const uploadFiles = async (key: UploadKey, response: PickerResult, sender: number, cid: string, docSize?: number) => {
	let filePath = response.path.startsWith('file://') ? response.path : 'file://' + response.path;

	let maxMetaSizeLimit = imSdk.getInstance().getMediaLimit(key, response.mimeType);
	console.log('maxMetaSizeLimit', maxMetaSizeLimit, 'mimeType', response.mimeType);
	if (maxMetaSizeLimit <= 0) {
		return { code: 0, cid: cid, msg: Str_NoSupportFileType };
	}

	let width = (response.width ?? 0) > 0 ? response.width : 0;
	let height = (response.height ?? 0) > 0 ? response.height : 0;

	if (response.type === MessageType.VIDEO) {
		if (response.isHadCompressed !== true) {
			const metaData = await getVideoMetaData(filePath);
			if (metaData.size > maxMetaSizeLimit) {
				try {
					filePath = await Video.compress(filePath, { compressionMethod: 'auto', maxSize: maxMetaSizeLimit });
				} catch (error) {
					return { code: 0, cid: cid, msg: "compress error" };
				}
			}
		}

		if (filePath.length != 0) {
			const metaData2 = await getVideoMetaData(filePath);
			if (metaData2.size > maxMetaSizeLimit) {
				return { code: 0, cid: cid, msg: Str_FileSizeLimit };
			}
			width = metaData2.width;
			height = metaData2.height;
		}
	} else if (response.type === 'photo') {
		// 获取图片文件大小
		const metaData = await getImageMetaData(filePath);
		if (metaData.size <= maxMetaSizeLimit) {
			width = metaData.ImageWidth;
			height = metaData.ImageHeight;
		} else {
			try {
				filePath = await Image.compress(filePath, { compressionMethod: 'manual', quality: 0.8 });
			} catch (error) {
				return { code: 0, cid: cid, msg: "compress error" };
			}
			const metaData2 = await getImageMetaData(filePath);
			if (metaData.size > maxMetaSizeLimit) {
				return { code: 0, cid: cid, msg: "compress error" };
			}
			width = metaData2.ImageWidth;
			height = metaData2.ImageHeight;
		}
	} else {
		if (docSize && docSize > maxMetaSizeLimit) {
			return { code: 0, cid: cid, msg: Str_FileSizeLimit };
		}
	}

	const split = filePath.split('.');
	const filetype = split[split.length - 1];
	const filemd5 = CryptEngine.md5(response.path);
	// files 数组
	const uri = isIos ? decodeURIComponent(filePath.replace('file://', '')) : filePath;
	// 不管iOS和安卓,都确保不带file://前缀的路径参与key的生成
	const k = `${sender}-${cid}-${CryptEngine.md5(decodeURIComponent(filePath.replace('file://', '')))}`; 
	console.log('upload res', { path: uri, fileName: filemd5, filetype: filetype, key: key, handleKey: k });
	const res = await ReactBlobUtil.upload({ path: uri, fileName: filemd5, filetype: filetype, key: key, handleKey: k });
	console.log('upload res', res);
	return { code: res.code, cid: cid, msg: res.msg, url: res.url };
};

export interface UploadFileManagerCallback {
	onUploadProgress: (progress: number) => void;
	onSuccess: () => void;
	onFail: () => void;
}

class UploadFileManager {
	private mMap = new Map<string, UploadFileManagerCallback>();
	private mProgressMap = new Map<string, number>();

	addProgress(key: string) {
		this.mProgressMap.set(key, 0);
	}

	isUpload(key: string) {
		return this.mProgressMap.has(key);
	}

	getProgress(key: string): number {
		if (this.mProgressMap.has(key)) {
			return this.mProgressMap.get(key) ?? 0;
		}
		return 0;
	}

	addListener(key: string, listener: UploadFileManagerCallback) {
		this.mMap.set(key, listener);
	}

	removeListener(key: string) {
		this.mMap.delete(key);
	}

	handleListener(key: string, progress: number) {
		console.log(`------------file upload 进度: ${progress}%  key: ${key}  mMap: ${JSON.stringify(Array.from(this.mMap.keys()))}`);
		this.mMap.forEach((v, k) => {
			if (key === k) {
				console.log(`------------file upload 触发回调: ${progress}%  key: ${key} ${v.onUploadProgress == undefined}`);
				v.onUploadProgress?.(progress);
				this.mProgressMap.set(key, progress);
			}
		});
	}

	handleSucListener(key: string) {
		this.mMap.forEach((v, k) => {
			if (key === k) {
				v.onSuccess?.();
				this.mProgressMap.delete(key);
			}
		});
	}

	handleFailListener(key: string) {
		this.mMap.forEach((v, k) => {
			if (key === k) {
				v.onFail?.();
				this.mProgressMap.delete(key);
			}
		});
	}
}
export const uploadFileManager = new UploadFileManager();
